import React from 'react';
import classNames from 'classnames';

const ICON_CLASSNAME = 'Icon';

const SvgIcon = React.forwardRef(({ name, svgProps, svgStyles, alt }, ref) => (
  <svg
    {...svgProps}
    ref={ref}
    className={svgStyles}
    data-testid={`icon-${name}`}
  >
    <use xlinkHref={'#icons-' + name} />
  </svg>
));

/**
 * @typedef {object} Props
 * @prop {boolean=} stabilize
 * @prop {string=} className
 * @prop {string} name
 *
 * @extends {React.Component<Props>}
 */
class Icon extends React.Component {
  constructor(props) {
    super(props);
    this.svg = React.createRef();
  }

  componentDidMount() {
    if (this.props.stabilize && typeof stabilizeSVG === 'function') {
      setTimeout(() => {
        if (this.svg.current) {
          stabilizeSVG(this.svg.current);
        }
      });
    }
  }

  render() {
    const { className, name, stabilize, small, ...props } = this.props;
    const svgProps = { ...props, name };
    const svgStyles = classNames(ICON_CLASSNAME, className, {
      [ICON_CLASSNAME + '--small']: small,
    });

    if (props['data-toggle'] === 'tooltip') {
      // Extract Bootstrap tooltip properties to be
      // applied to wrapping span
      const {
        'data-toggle': dataToggle,
        'data-original-title': dataOriginalTitle,
        'data-placement': dataPlacement,
        'data-html': dataHtml,
        'data-delay': dataDelay,
        title: dataTitle,
        svgClassName,
        ...cleanedSvgProps
      } = svgProps;
      const title = dataOriginalTitle || dataTitle;

      // We apply a wrapping span, because we cannot, with version 3.3.7+ Bootstrap,
      // apply tooltips directly to SVGs. It does not calculate svg offset for scrolled pages.
      // https://github.com/twbs/bootstrap/issues/20280
      return (
        <span
          data-toggle={dataToggle}
          data-placement={dataPlacement}
          data-html={dataHtml}
          data-delay={dataDelay}
          title={title}
          className={className}
        >
          <SvgIcon
            ref={this.svg}
            name={name}
            svgProps={cleanedSvgProps}
            svgStyles={classNames(ICON_CLASSNAME, svgClassName)}
          />
        </span>
      );
    }

    return (
      <SvgIcon
        ref={this.svg}
        name={name}
        svgProps={svgProps}
        svgStyles={svgStyles}
      />
    );
  }
}

Icon.defaultProps = {
  stabilize: true,
};

export default Icon;
